/* eslint-disable no-unused-vars */
export const getChecklistProgress = (points = []) => {
  const total = points.length
  if (!total) return { isDone: 0, total: 0, percent: 0 }

  const isDone = points.reduce((acc, p) => acc + (p.is_done ? 1 : 0), 0)
  const rawPercent = (isDone * 100) / total
  const percent = Math.min(100, Math.max(0, Math.round(rawPercent)))

  return { isDone, total, percent }
}

export const moveInArray = (arr, from, to) => {
  const copy = arr.slice()
  const [item] = copy.splice(from, 1)
  copy.splice(to, 0, item)
  return copy
}

export const deleteInArray = (arr, index) => {
  return [...arr.slice(0, index), ...arr.slice(index + 1)]
}

export const stripPositionId = (lists) =>
  lists.map(({ id, name, points }) => ({
    ...(id != null ? { id } : {}),
    name,
    points: points.map(({ positionId, ...rest }) => rest),
  }))

export const toFormikChecklists = (src) => {
  return src.map(({ id, name, points = [] }) => {
    const cleanedPoints = points.map(({ id, text, is_done }, idx) => ({
      id,
      text,
      is_done,
      positionId: idx,
    }))

    return { id, name, points: cleanedPoints }
  })
}

export const createChecklists = () => ({
  name: 'Чек-лист',
  points: [
    {
      positionId: 0,
      text: '',
      is_done: false,
    },
  ],
})

export const makePoint = (positionId, text = '') => ({
  positionId,
  text: text,
  is_done: false,
})

export const getNextPositionId = (points) => {
  const ids = points
    .map((p) => (p?.positionId ? p.positionId : null))
    .filter((v) => v !== null)
  return ids.length ? Math.max(...ids) + 1 : 1
}

export const prepareChecklistPointsForTransfer = (checklist) => {
  const { id, ...restChecklist } = checklist

  return [
    {
      ...restChecklist,
      points: checklist.points.map((point) => {
        const { positionId, id, ...restPoint } = point
        return { ...restPoint, is_done: false }
      }),
    },
  ]
}
